import React from 'react';
import styles from './LowTakeupSchools.module.scss';
import commonStyles from '../../DataDashboard.module.scss';
import BackLink from '../../../../components/BackLink';
import { Button } from '@squirrellearningltd/go-teacher-components';

import { useQuery } from '@apollo/react-hooks';
import { SCHOOL_USAGE_SCORE } from '../../services/graphql';
import useClipboard from '../../utils/copyToClipboard';

import { navigate } from '@reach/router';


const LowTakeupSchools = () => {
    const { copyToClipboard, isCopied, error } = useClipboard();
    const { data: schoolData, loading: schoolDataLoading, error: schoolDataError } = useQuery(SCHOOL_USAGE_SCORE);

    const copyEmails = () => {
        if (schoolData.schoolUsageScore) {
            const adminEmails = schoolData.schoolUsageScore.map((schoolUsage) => schoolUsage.school.admins.map((admin) => admin.email)).flat();
            const copyParser = (data) => data.filter(Boolean).join(';');
            copyToClipboard(adminEmails, copyParser);
        } else {
            alert('No data to copy');
        }

    };

    return (
        <>
            <BackLink to='/dataDashboard' text='Back' />

            <div className={commonStyles.dataDashboardHeader}>
                <h2>Low Take-up Schools</h2>
                <Button type='button' onClick={() => copyEmails()}>
                    Copy Emails
                </Button>
            </div>

            <div className={styles.contentContainer}>
                <div className={styles.contentHeadline}>
                    <div>School Name</div>
                    <div>Usage</div>
                </div>
                <div className={styles.contentValues}>

                    {schoolDataLoading && <p>Loading...</p>}
                    {schoolDataError && <p>{schoolDataError.message}</p>}
                    {
                        schoolData && [...schoolData.schoolUsageScore].length ? schoolData.schoolUsageScore.map((schoolUsageScore, index) =>
                            <div key={index}
                                className={styles.contentValueRow}
                                onClick={() => navigate(`/dataDashboard/schoolStats/schoolHome/${schoolUsageScore.school.id}`)}>


                                <div>{schoolUsageScore.school.name} ({schoolUsageScore.school.schoolCode})</div>
                                <div className={styles.usageValue}>{schoolUsageScore.teachersEngagementPercentage ?? 0}%</div>
                            </div>
                        ) : !schoolDataLoading && <p>No data available</p>
                    }
                </div>
            </div>
        </>
    );
};

export default LowTakeupSchools;
